import { render, staticRenderFns } from "./AllModeleSelection.vue?vue&type=template&id=12893a7f&"
import script from "./AllModeleSelection.vue?vue&type=script&lang=js&"
export * from "./AllModeleSelection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports